Greenmile.Actions = Greenmile.Actions || {};
Greenmile.Actions.DatabaseIntegration = {
  template: () => ({
    tag: 'div',
    items: [
      {
        tag: 'label',
        items: [
          {
            tag: 'span',
            html: 'event.db.username',
            attributes: {
              class: 'i18nResource',
            },
          },
        ],
        attributes: {
          class: 'control-label',
          for: 'action_db_username',
        },
      },
      {
        items: [
          {
            tag: 'input',
            attributes: {
              type: 'text',
              maxlength: '120',
              name: 'action_db_username',
              id: 'action_db_username',
              class: 'modelAttribute textField mandatory',
              autocomplete: 'off',
            },
          },
        ],
        attributes: {
          class: 'controls',
        },
      },
      {
        tag: 'label',
        items: [
          {
            tag: 'span',
            html: 'event.db.password',
            attributes: {
              class: 'i18nResource',
            },
          },
        ],
        attributes: {
          class: 'control-label',
          for: 'action_db_password',
        },
      },
      {
        items: [
          {
            tag: 'input',
            attributes: {
              type: 'password',
              maxlength: '120',
              name: 'action_db_password',
              id: 'action_db_password',
              class: 'modelAttribute textField mandatory',
            },
          },
        ],
        attributes: {
          class: 'controls',
        },
      },
      {
        tag: 'label',
        items: [
          {
            tag: 'span',
            html: 'event.db.url',
            attributes: {
              class: 'i18nResource',
            },
          },
        ],
        attributes: {
          class: 'control-label',
          for: 'action_db_url',
        },
      },
      {
        items: [
          {
            tag: 'input',
            attributes: {
              type: 'text',
              maxlength: '80',
              name: 'action_db_url',
              id: 'action_db_url',
              class: 'modelAttribute textField mandatory',
              autocomplete: 'off',
            },
          },
        ],
        attributes: {
          class: 'controls',
        },
      },
      {
        tag: 'label',
        items: [
          {
            tag: 'span',
            html: 'event.db.driverclass',
            attributes: {
              class: 'i18nResource',
            },
          },
        ],
        attributes: {
          class: 'control-label',
          for: 'action_db_driverClass',
        },
      },
      {
        items: [
          {
            tag: 'input',
            attributes: {
              type: 'text',
              maxlength: '80',
              name: 'action_db_driverClass',
              id: 'action_db_driverClass',
              class: 'modelAttribute textField mandatory',
              autocomplete: 'off',
            },
          },
        ],
        attributes: {
          class: 'controls',
        },
      },
      {
        tag: 'label',
        items: [
          {
            tag: 'span',
            html: 'event.db.statement',
            attributes: {
              class: 'i18nResource',
            },
          },
        ],
        attributes: {
          class: 'control-label',
          for: 'action_db_statement',
        },
      },
      {
        items: [
          {
            tag: 'textarea',
            attributes: {
              cols: '110',
              rows: '4',
              name: 'action_db_statement',
              id: 'action_db_statement',
              class: 'modelAttribute textAreaField mandatory autocomplete_entity',
            },
          },
        ],
        attributes: {
          class: 'controls',
        },
      },
    ],
  })
};
